import { labels } from './labels.js';
import Vue from 'vue';

export var store = {
    state: {
        settings: {
            customerId: 0,
            langId: Cookies.get('marketplace-lang'),
            tagId: 0,
            storeSettings: {}
        },
        selectedSortBy: 1,
        currentPage: 1,
        pageSize: 6,
        sortBy: [
            {
                Id: 1,
                Name: '_sortByNameAsc'
            },
            {
                Id: 2,
                Name: '_sortByNameDesc'
            }
        ],
        productsView: {
            AllFilterGroups: [{}],
            AllFilters: [],
            Products: []
        },
        status: {            
            isLoading: true,
            isFetching: false,
            isClearing: false,
            isFilterDisplayed: false,
            isAdding: false,
            isFirstLoadComplete: false
        },
        keys: labels,
        labels: []
    },
    getAppliedSortBy: function () {
        var index = _.findIndex(this.state.sortBy, function (o) {
            return o.Id == store.state.selectedSortBy;
        });

        return store.state.sortBy[index];
    },
    getFiltersByType: function (type) {
        var filters = _.filter(store.state.productsView.AllFilters, function (o) {
            return o.FilterType == type;
        });

        filters = _.sortBy(filters, ['Name'], ['asc']);

        return filters;
    },
    getFiltersByGroup: function (groupId) {
        var filters = _.filter(store.state.productsView.AllFilters, function (o) {
            return o.FilterGroupId == groupId && o.FilterType == "tag";
        });

        filters = _.orderBy(filters, ['Sequence'], ['asc']);

        return filters;
    },
    getFiltersByParent: function (parentId, level) {

        var result = [];

        var filters = _.filter(store.state.productsView.AllFilters, function (o) {
            return o.ParentId == parentId;
        });

        filters = _.orderBy(filters, ['Sequence'], ['asc']);

        for (var i = 0; i < filters.length; i++) {
            filters[i].Level = level;

            // Get other childs
            var subTags = _.filter(store.state.productsView.AllFilters, function (o) {
                return o.ParentId == filters[i].Id;
            });

            subTags = _.orderBy(subTags, ['Sequence'], ['asc']);
            
            _.forEach(subTags, function (filter) {
                filter.Level = level + 1;
            });

            result = _.concat(result, filters[i], subTags);
        }

        return result;
    },
    getLooseFilters: function () {
        var filters = _.filter(store.state.productsView.AllFilters, function (o) {
            return o.FilterGroupId == 0 && o.FilterType == "tag";
        });

        // Find smallest parent id
        var parentId = -1;
        _.forEach(filters, function (filter) {
            if (parentId == -1) {
                parentId = filter.ParentId;
            }

            if (parentId > filter.ParentId) {
                parentId = filter.ParentId;
            }
        });

        var sortedTags = [];
        var rootFilters = _.filter(filters, function (o) {
            return o.ParentId == parentId;
        });

        // Sort all filters and assigned the proper level
        for (var i = 0; i < rootFilters.length; i++) {
            rootFilters[i].Level = 0;
            var filtersByParent = store.getFiltersByParent(rootFilters[i].Id, 1);
            sortedTags = _.concat(sortedTags, rootFilters[i], filtersByParent);
        }

        _.forEach(filters, function (filter) {

            var index = _.findIndex(sortedTags, function (o) {
                return o.Id == filter.Id;
            });

            if (index == -1) {
                sortedTags.push(filter);
            }
        });

        return sortedTags;
    },
    getView: function () {

        if (store.state.settings.tagId == 0) {
            return;
        }

        var self = this;
        self.state.status.isLoading = true;
        return $.ajax({
            url: '/api/APIStoreCategory/GetProducts',
            type: 'GET',
            data: {
                categoryId: store.state.settings.tagId,
                langId: self.state.settings.langId,
                customerId: self.state.settings.customerId,
                pageSize: self.state.pageSize,
                pageNumber: self.state.currentPage
            }
        })
            .done(function (data) {
                self.state.productsView = data;
                if (self.state.status.isFirstLoadComplete == false) {
                    self.state.status.isFirstLoadComplete = true;
                }                
            })
    },
    getLabels: function () {
        $.ajax({
            url: '/api/APIStore/GetLabels',
            type: 'GET',
            data: {
                langId: store.state.settings.langId,
                keys: store.state.keys
            }
        })
            .done(function (data) {
                store.state.labels = data;
            })
    },
    getLabel: function (key) {
        var index = _.findIndex(store.state.labels, function (o) {
            return o.Key == key;
        });

        if (index == -1) {
            return "";
        }

        return store.state.labels[index].Value;
    },
    getProductCount: function () {
        var productCount = 0;
        productCount = this.state.productsView.Products.length;

        return productCount;
    },
    getCategoryProductCount: function () {
        var productCount = 0;
        productCount = this.state.productsView.ProductCount;

        return productCount;
    },
    getAppliedFilters: function () {

        var appliedFilters;
        appliedFilters = _.filter(store.state.productsView.AllFilters, function (o) {
            return o.Checked == true;
        });

        return appliedFilters;
    },
    getSettings: function () {

        var self = this;
        return $.ajax({
            type: 'GET',
            url: '/api/APIStore/GetSettings'
        })
            .done(function (data) {
                self.state.settings.storeSettings = data;
            })
    },
    setSortBy: function (id) {
        this.state.selectedSortBy = id;
    },
    removeFilter: function (filter) {
        var index = _.findIndex(store.state.productsView.AllFilters, function (o) {
            return o.FilterType == filter.FilterType && o.Id == filter.Id;
        });

        store.state.productsView.AllFilters[index].Checked = false;
    },
    toggleFilter: function () {
        this.state.status.isFilterDisplayed = !this.state.status.isFilterDisplayed;
    },
    hideFilter: function () {
        if (this.state.status.isFilterDisplayed == true) {
            this.state.status.isFilterDisplayed = false;
        }
    },
    filter: function (clear) {

        if (store.state.settings.tagId == 0) {
            return;
        }

        var self = this;
        self.state.status.isFetching = true;
        // Set the page to number 1 each time we filter
        self.state.currentPage = 1;

        var filters = [];
        if (clear == false || clear == undefined) {
            filters = _.filter(store.state.productsView.AllFilters, function (o) {
                return o.Checked == true;
            });
        }
        
        var filtersVM = {
            Id: store.state.settings.tagId,
            SortBy: store.state.selectedSortBy,
            AllFilters: filters,
            CustomerId: store.state.settings.customerId,
            LangId: store.state.settings.langId,
            pageSize: self.state.pageSize,
            pageNumber: self.state.currentPage
        };

        $.ajax({
            url: '/api/APIStoreCategory/GetProducts',
            type: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(filtersVM)
        })
            .done(function (data) {
                store.state.productsView = data;
            })
            .fail(function () {
                var errorMsg = store.getLabel('_webservererror');
                toastr["error"](errorMsg);
            })
            .always(function () {
                self.state.status.isFetching = false;
                Vue.nextTick(function () {
                    AdjustCardSize();
                });
            })

    },
    loadMoreWithFilters: function (filters) {
        var self = this;
        self.state.status.isAdding = true;

        var filtersVM = {
            Id: store.state.settings.tagId,
            SortBy: store.state.selectedSortBy,
            AllFilters: filters,
            CustomerId: store.state.settings.customerId,
            LangId: store.state.settings.langId,
            pageSize: self.state.pageSize,
            pageNumber: self.state.currentPage
        };

        return $.ajax({
            url: '/api/APIStoreCategory/GetProducts',
            type: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(filtersVM)
        })
            .done(function (data) {

                data.Products.forEach(function (item, index) {
                    item.IsFetched = false;
                    store.state.productsView.Products.push(item);
                })
            })
            .always(function () {
                self.state.status.isAdding = false;
                Vue.nextTick(function () {
                    AdjustCardSize();
                });
            })
    },
    loadMoreWithoutFilters: function () {                
        var self = this;
        self.state.status.isAdding = true;
        return $.ajax({
            url: '/api/APIStoreCategory/GetProducts',
            type: 'GET',
            data: {
                categoryId: store.state.settings.tagId,
                langId: self.state.settings.langId,
                customerId: self.state.settings.customerId,
                pageSize: self.state.pageSize,
                pageNumber: self.state.currentPage
            }
        })
            .done(function (data) {                
                data.Products.forEach(function (item, key) {
                    item.IsFetched = false;
                    self.state.productsView.Products.push(item);
                });                
            })
            .always(function () {
                self.state.status.isAdding = false;
                Vue.nextTick(function () {
                    AdjustCardSize();
                });
            })
    },
    loadMore: function () {
        var self = this;
        var isComplete = self.state.productsView.Products.length >= self.state.productsView.ProductCount;
        var isAdding = self.state.status.isAdding;
        var isFetching = self.state.status.isFetching;
        var isLoading = self.state.status.isLoading;
        var isFirstLoadComplete = self.state.status.isFirstLoadComplete;

        if (isAdding == true || isComplete == true || isFetching == true || isLoading == true || isFirstLoadComplete == false) {
            return;
        }

        this.state.currentPage++;

        var filters = _.filter(store.state.productsView.AllFilters, function (o) {
            return o.Checked == true;
        });

        if (filters.length > 0) {
            this.loadMoreWithFilters(filters);
        }
        else {
            this.loadMoreWithoutFilters();
        }
    },
    init: function (callback) {
        // Get tagId
        var url = window.location.href;
        var lastIndex = url.lastIndexOf('/') + 1;
        var tagId = url.substr(lastIndex);
                
        store.state.settings.tagId = tagId;
        
        // Set Toastr options
        toastr.options = {
            "closeButton": true,
            "debug": false,
            "newestOnTop": false,
            "progressBar": false,
            "positionClass": "toast-top-right",
            "preventDuplicates": false,
            "onclick": null,
            "showDuration": "1000",
            "hideDuration": "1000",
            "timeOut": "5000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        };

        $.when(
            store.getSettings()
        ).then(function () {

            $.when(
                store.getView(),
                store.getLabels()
            )
            .then(function () {
                // Set sort by options
                if (store.state.settings.storeSettings.ShowPrice == true) {
                    store.state.sortBy.push({
                        Id: 3,
                        Name: '_sortByPriceAsc'
                    });

                    store.state.sortBy.push({
                        Id: 4,
                        Name: '_sortByPriceDesc'
                    });
                }

                // Set page title
                var storeName = store.state.settings.storeSettings.StoreTitle == "" ?
                    store.state.settings.storeSettings.StoreName :
                    store.state.settings.storeSettings.StoreTitle;

                $('head title').text(storeName + ' - ' + store.state.productsView.Name);

                store.state.status.isLoading = false;

                if (callback) {
                    callback();
                }
            })

        })
        
    }
}